import script from "./recommend.vue?vue&type=script&setup=true&lang=js"
export * from "./recommend.vue?vue&type=script&setup=true&lang=js"

import "./recommend.vue?vue&type=style&index=0&id=20ddec0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ddec0c"]])

export default __exports__